import { bootstrapApplication } from '@angular/platform-browser';
import { initSentry, setupAngularSentry, captureException } from '@portal-front/shared-util-sentry';

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { config } from './configuration';

const { environmentName, sentry: sentryConfig, buildVersion } = config();

initSentry({ ...sentryConfig, environmentName, release: buildVersion });

bootstrapApplication(AppComponent, setupAngularSentry(appConfig)).catch((err) => {
  captureException(err);
  console.error(err);
});
